import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/inter';

import App from './App';
import ErrorFallback from './components/ErrorFallback';
import { initSentry, Sentry } from './sentry';
import { blindarContraTradutor } from './utils/blindagemTradutor';
import { ehErroDeRenderStale, instalarRecuperacaoDeBundleStale, recarregarBundleStale } from './utils/bundleStale';

blindarContraTradutor();
// Sentry sobe antes do app pra capturar erros de inicialização.
initSentry();
instalarRecuperacaoDeBundleStale();

// Erro de render típico de bundle velho só aparece dentro do ErrorBoundary.
function aoQuebrarRender(erro) {
  if (ehErroDeRenderStale(erro)) recarregarBundleStale();
}

createRoot(document.getElementById('root')).render(
  <Sentry.ErrorBoundary fallback={(props) => <ErrorFallback {...props} />} onError={aoQuebrarRender}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Sentry.ErrorBoundary>,
);
